import React from "react";
import { Link } from "react-router-dom";
import UV_Treatment from "../media/uvtreat.jpg";
import RO from "../media/evosm.jpg";
import Ozonisation from "../media/oproc.jpg";
import { useEffect } from "react";
import Product from "./Product";
import Testimonial from "./Testimonial";
import Reviews from "./Reviews";

const NgoWaters = () => {
  useEffect(() => {
    // Scroll to top when this page is rendered
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Carousel Section */}
      <div className="container my-5">
        <div
          id="ngoCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                src={UV_Treatment}
                className="d-block w-100 img-fluid rounded"
                style={{ height: "500px", objectFit: "cover" }}
                alt="First Slide"
              />
              <div className="carousel-caption d-md-block bg-dark bg-opacity-75 p-2 rounded">
                <h5>Ultra-Violet (UV) Treatment</h5>
                <p>
                  Eliminates harmful microorganisms effectively, ensuring clean
                  water.
                </p>
              </div>
            </div>
            <div className="carousel-item">
              <img
                src={RO}
                className="d-block w-100 img-fluid rounded"
                style={{ height: "500px", objectFit: "cover" }}
                alt="Second Slide"
              />
              <div className="carousel-caption d-md-block bg-dark bg-opacity-75 p-2 rounded">
                <h5>Reverse Osmosis (RO)</h5>
                <p>
                  Removes impurities and improves the quality of drinking water.
                </p>
              </div>
            </div>
            <div className="carousel-item">
              <img
                src={Ozonisation}
                className="d-block w-100 img-fluid rounded"
                style={{ height: "500px", objectFit: "cover" }}
                alt="Third Slide"
              />
              <div className="carousel-caption d-md-block bg-dark bg-opacity-75 p-2 rounded">
                <h5>Ozonation Process</h5>
                <p>Ensures freshness and purity of water before packaging.</p>
              </div>
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#ngoCarousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#ngoCarousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      {/* About Section */}
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <div className="card border-0 shadow-sm p-4">
              <h3 className="mb-3">About NGO Waters</h3>
              <p className="text-muted">
                NGO Waters is committed to providing clean and safe bottled
                water to communities in need. Our water is sourced from pure
                springs, undergoing rigorous purification to ensure health
                standards. We aim to create a future where everyone has access
                to high-quality drinking water.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Products */}
      <br />
      <br />
      <br />

      <Product />
      <br />
      <br />
      <br />
      <Testimonial />
      <br />
      <br />
      <br />
      <Reviews />
      {/* Call-to-Action Section */}
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <p className="lead">
              Bulk orders for{" "}
              <b>
                <span className="bg-info p-1 m-1">HO</span> &nbsp;
                <span className="bg-info p-1 m-1">RE</span> &nbsp;
                <span className="bg-info p-1 m-1">CA</span> &nbsp;
              </b>
              and schools, colleges, hospitals, and more, click:
            </p>
            <Link to="/bulkorder" className="btn btn-success btn-lg mx-2">
              Bulk Order
            </Link>
            <Link to="/contact" className="btn btn-primary btn-lg mx-2">
              Contact Form
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NgoWaters;
